import api from "../utils/api.js";
import {
    MIN_PRICE,
    MAX_PRICE,
    FILTERS,
    SEASON_FILTER,
    OCCASION_FILTER,
    PRICE_FILTER,
    SORT_FILTER,
} from "../../config";

const defaultSelectedFilters = { optionValues: [], pricePercentage: null, sort:  { type: '', order: '' } };

export const filters = {
    namespaced: true,
    state: {
        selectedFilters: defaultSelectedFilters,
        filters: {},
        selectedSavedProductsCategoryFilterIndex: 0,
        selectedSavedProductsCategoryId: null,
        selectedSortIndex: null,
        savedProductFilters: null,
        filtersForPage: null,
    },
    getters: {
        selectedFilters(state) {
            const { pricePercentage, optionValues, sort } = state.selectedFilters;

            return {
                pricePercentage,
                optionValues: Object.keys(optionValues).filter(optionId => !!optionValues[optionId]),
                sort,
            };
        },
        getPricePercentage(state) {
            return state.selectedFilters.pricePercentage;
        },
        getSelectedOptions(state) {
            return state.selectedFilters.optionValues;
        },
        getOccasionFilter(state) {
            const occasions = state.filters[OCCASION_FILTER];
            if(!occasions) return [];

            return occasions.options;
        },
        getSeasonFilter(state) {
            const seasons = state.filters[SEASON_FILTER];
            if(!seasons) return [];

            return seasons.options;
        },
        selectedSavedProductsCategoryFilterIndex(state) {
            return state.selectedSavedProductsCategoryFilterIndex;
        },
        savedProductFilters(state) {
            return state.savedProductFilters;
        },
        selectedSavedProductsCategoryId(state) {
            if(state.selectedSavedProductsCategoryId > -1) {
                return state.selectedSavedProductsCategoryId
            }
        },
        filtersForPage(state) {
            return state.filtersForPage;
        },
        sortOptionIndexSelected(state) {
            return state.selectedSortIndex;
        },
        getSortOptions(state) {
            const sort = state.filters[SORT_FILTER];
            if(!sort) return [];

            return sort.options;
        },
    },
    mutations: {
        setSelectedFilters(state, selectedFilters) {
            state.selectedFilters = selectedFilters;

        },
        setSelectedFilter(state, selectedFilter) {
            state.selectedFilters = {
                ...state.selectedFilters,
                ...selectedFilter,
            };
        },
        setFilterOptions(state, payload) {
            const { name } = payload;
            let { options } = payload;

            state.filters = {
                ...state.filters,
                [name]: {
                    name,
                    options,
                }
            };
        },
        resetState(state) {
            state.selectedFilters = defaultSelectedFilters;
            state.selectedSortIndex = null;
        },
        resetSelectedFilters(state) {
            state.selectedFilters = defaultSelectedFilters;
            state.selectedSortIndex = null;
        },
        setSelectedSavedProductsCategoryFilter(state, payload) {
            state.selectedSavedProductsCategoryFilterIndex = payload.index;
            state.selectedSavedProductsCategoryId = payload.filter.product_category_id;
        },
        setSavedProductFilters(state, filters){
            state.savedProductFilters = filters;
        },
        setFiltersForPage(state, page) {
            state.filtersForPage = page;
        },
        setSelectedSortIndex(state, index) {
            state.selectedSortIndex = index;
        },
    },
    actions: {
        fetchFilters(context) {
            return Promise.all(FILTERS.map((filterType) => context.dispatch('fetchFilterOption', { filterType })));
        },
        fetchFilterOption(context, payload) {
            const { filterType } = payload;
            const uri = api.filtersUri() + filterType;

            return api
                .get(uri)
                .then(response => {
                    context.commit('setFilterOptions', {
                        name: filterType,
                        options: response.filter.product_option_values,
                    });
                })
                .catch(error => {
                    console.log('error loading filters');
                });
        },
        applyFilters(context) {
            context.dispatch('generatedOutfits/fetchNewOutfits', null, { root:true });
        },
        fetchSavedProductFilters(context, payload){
            let uri = api.filtersUri() + 'categories';
            return api
                .get(uri)
                .then(response => {
                    let emptyCategory = {
                        product_category_title: 'All',
                        product_category_id: -1,
                    };

                    response.categories.unshift(emptyCategory);
                    context.commit('setSavedProductFilters', response.categories)
                })
                .catch(error =>{
                    throw error;
                })
        }
    }
}